import { appCode } from '../../config';

// use this approach to split the code of a component, and bundle it as a separate chunk that is loaded lazily
const Home = () => import('../views/Home.vue');

export default [
  // {
  //   path: `/${appCode}/`,
  //   redirect: `/${appCode}/home`,
  // },
  // {
  //   path: `/${appCode}/home`,
  //   name: `${appCode}:home`,
  //   components: { [appCode]: Home },
  // },
  {
    path: `/${appCode}/feature/:featureId?`,
    name: `${appCode}:feature`,
    components: { [appCode]: Home },
    props: { [appCode]: true },
  },
  // {
  //   path: `/${appCode}/:pathMatch(.*)`,
  //   redirect: `/${appCode}/home`,
  // },
];
